// Conditional polyfills loaded before any dependent module. Top-level await
// in this file blocks evaluation of main.tsx's later static imports, so
// paraglide's runtime sees `globalThis.URLPattern` populated by the time it
// reads from the urlpattern-polyfill alias stub (src/stubs/urlpattern-polyfill.ts).
//
// We import from the `/urlpattern` subpath rather than the package's main
// entry: the bare specifier is aliased to the stub, and the subpath gives
// us the URLPattern class without the package's own side-effect that
// blanket-imports the polyfill into the static chunk graph.
if (typeof URLPattern === 'undefined') {
  const polyfill = await import('urlpattern-polyfill/urlpattern');
  Object.defineProperty(globalThis, 'URLPattern', {
    value: polyfill.URLPattern,
    configurable: true,
    writable: true,
  });
}

export {};
